import { COMMON_HEADERS } from '@xsscool/shared';
import { useStore } from '../store';
import { HeaderRow } from './HeaderRow';

export function HeadersPanel() {
  const headers = useStore((s) => s.headers);
  const addHeader = useStore((s) => s.addHeader);
  const clearHeaders = useStore((s) => s.clearHeaders);

  return (
    <div className="pane headers-pane">
      <datalist id="header-name-suggestions">
        {COMMON_HEADERS.map((h) => (
          <option key={h.name} value={h.name} />
        ))}
      </datalist>

      {headers.length === 0 && (
        <p className="hint">No headers yet. Add one below or pick a preset.</p>
      )}

      {headers.map((h) => (
        <HeaderRow key={h.id} row={h} />
      ))}

      <div className="headers-actions">
        <button onClick={() => addHeader()}>+ Add header</button>
        {headers.length > 0 && (
          <button onClick={clearHeaders} className="danger">
            Clear all
          </button>
        )}
      </div>

      <h3 className="presets-heading">Presets</h3>
      <div className="headers-actions">
        {COMMON_HEADERS.map((h) => (
          <button key={h.name} onClick={() => addHeader({ name: h.name, value: h.value })}>
            {h.name}
          </button>
        ))}
      </div>
    </div>
  );
}
